import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageElementSpec } from '../../../classes/page-element-spec';
import { ISessionDetails } from '../../../interfaces/session-details';
import { ISubaccountSpec } from '../../../interfaces/account/subaccount-spec';
import { DynamicPageElementComponent } from '../../section-blocks/dynamic-page-element/dynamic-page-element.component';
import { WalPageService } from '../../../services/session/wal-page.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-subaccounts-accordion',
    standalone: true,
    imports: [
        CommonModule,
        DynamicPageElementComponent
    ],
    templateUrl: './subaccounts-accordion.component.html',
    styleUrl: './subaccounts-accordion.component.css'
})
export class SubaccountsAccordionComponent implements OnInit {

  private readonly walPageService = inject(WalPageService);
  private readonly dataExchangeService = inject(DataExchangeService);
  private readonly logger = inject(NGXLogger);

  accountDataPoints: PageElementSpec<string>[] = [];
  subaccounts: ISubaccountSpec[] = [];
  subaccountType!: string;

  ngOnInit() {
    let region: string = this.dataExchangeService.getRegion();
    let sessionDetails: ISessionDetails = this.dataExchangeService.getSession();
    let serialNumber: string = '';
    // Find out the serial number
    if (sessionDetails.options) {
        const options: Map<string, string> = new Map(Object.entries(sessionDetails.options));
        if (options) {
            if (options.has("serialNumber")) {
                serialNumber = options.get('serialNumber') || '';
            }
        }
    }
    this.walPageService.getSubaccounts(region, sessionDetails.walPageUuid, sessionDetails.brandCode || '', serialNumber)
    .subscribe({
      next: (response) => {
        if (response) {
            console.log('response', response);
            this.subaccounts = response;
        }
      },
      error: (error) => {
        },
      complete: () => {
      }
    });

  }

  trackBySubaccount(index: number, subaccount: any): number {
    return subaccount.subacctId;
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }

}


    // this.subaccountType = "INVOICE";
    // this.subaccounts =
    // [
    //   {
    //       "subAccountId": "2006564371",
    //       "pageElements": [
    //           {
    //               "label": "INVOICE NUMBER",
    //               "value": "2006564371",
    //               "key": ""
    //           },
    //           {
    //               "label": "ORIGINAL INVOICE AMOUNT",
    //               "value": "1203.66",
    //               "key": ""
    //           },
    //           {
    //               "label": "TOTAL INVOICE DUE",
    //               "value": "1203.66",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE DATE",
    //               "value": "08/01/2024",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE DUE DATE",
    //               "value": "08/22/2024",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE SOURCE",
    //               "value": "BC",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE TYPE",
    //               "value": "Insured",
    //               "key": ""
    //           }
    //       ]
    //   },
    //   {
    //     "subAccountId": "2006564373",
    //       "pageElements": [
    //           {
    //               "label": "INVOICE NUMBER",
    //               "value": "2006564373",
    //               "key": ""
    //           },
    //           {
    //               "label": "ORIGINAL INVOICE AMOUNT",
    //               "value": "1503.66",
    //               "key": ""
    //           },
    //           {
    //               "label": "TOTAL INVOICE DUE",
    //               "value": "1218.66",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE DATE",
    //               "value": "09/01/2024",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE DUE DATE",
    //               "value": "09/22/2024",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE SOURCE",
    //               "value": "BC",
    //               "key": ""
    //           },
    //           {
    //               "label": "INVOICE TYPE",
    //               "value": "Insured",
    //               "key": ""
    //           }
    //       ]
    //   }

    // ]
